/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';

export default class Error extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h1 className="mt-5">Brosell Error</h1>
            <p className="lead">Oops</p>
          </div>
        </div>
      </div>
    );
  }
}
